import { Component } from '@angular/core';

@Component({
    selector: 'ds-sites-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    sites: Site[];

    ngOnInit() {
        this.sites = [
            {
                url: 'http://bekes.doxasoft.hu',
                name: 'Békés'
            },
            {
                url: 'http://doxahelp.doxasoft.hu',
                name: 'Doxa Help'
            },
            {
                url: 'http://eper.doxasoft.hu',
                name: 'Eper'
            },
            {
                url: 'http://financetracker.doxasoft.hu',
                name: 'Finance Tracker'
            },
            {
                url: 'http://prayer.doxasoft.hu',
                name: 'Ima lista'
            },
            {
                url: 'http://prestashop.doxasoft.hu',
                name: 'PrestaShop teszt'
            },
            {
                url: 'http://timelog.doxasoft.hu',
                name: 'Time log'
            },
        ];
    }
}

interface Site {
    url: string;
    name: string;
}



// WEBPACK FOOTER //
// /Users/manuel/Sites/doxasoft/sites/src/app/app.component.ts